import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import { IRegisterConsentCreate } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId } from '../../utils/helpers'
import { coreAPIV3 } from '../../services/coreAPIV3'

type TRegisterUserConsentMutationResult = UseMutationResult<
  AxiosResponse<void>,
  AxiosError<IError>,
  {
    payload: IRegisterConsentCreate
  }
>

export const useRegisterUserConsent = () => {
  return useMutation([`registerUserConsent`], (params) =>
    coreAPIV3
      .misc()
      .registerUserConsent(generateCorrelationId(), params.payload)
  ) as TRegisterUserConsentMutationResult
}
